import { NavLink, Link, useHistory } from "react-router-dom";
import style from "./index.module.css";
import Button from "../../../components/UI/Button";
import { useTranslation } from "../../../hooks/useTranslation";
import { vehicleModules, VehicleNames, vehicleTypes } from "../../../utils/GeneralTypes";
import {
  selectTypeCategories,
  selectTypeCategoriesError,
  selectTypeCategoriesLoading,
} from "../../../store/vehicleTypeCategoriesSlice";
import { useTypedSelector } from "../../../store/store";
import { Plus } from "lucide-react";
import { navLinkIsActive } from "./shared";

function DesktopMenuItem(vehicleModule: VehicleNames) {
  const { locale } = useTranslation();
  const categories = useTypedSelector((state) => selectTypeCategories(state, vehicleModule.single));
  const isLoading = useTypedSelector((state) => selectTypeCategoriesLoading(state, vehicleModule.single));
  const error = useTypedSelector((state) => selectTypeCategoriesError(state, vehicleModule.single));

  // TODO: add better loading state
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!categories) return null;

  return (
    <li className={style.menu_parent}>
      <span>{locale(vehicleModule.plural)}</span>
      <ul>
        {categories.map((category, index) => (
          <li key={index}>
            <NavLink
              to={`/used-${vehicleModule.plural}/find?category0=${category.id}`}
              className={(isActive) => {
                return isActive ? style.active : "";
              }}
              isActive={navLinkIsActive(category.id.toString())}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  overflowX: "hidden",
                  textOverflow: "ellipsis",
                  alignItems: "center",
                  gap: "7px",
                }}
              >
                {category.icon && (
                  <img
                    style={{
                      height: "20px",
                      width: "25px",
                      objectFit: "contain",
                    }}
                    src={category.icon}
                    alt=""
                  />
                )}
                {category.name}
              </div>
            </NavLink>
          </li>
        ))}
      </ul>
    </li>
  );
}

function DesktopHeader() {
  const { locale } = useTranslation();
  const history = useHistory();

  return (
    <>
      {vehicleModules.map((module, index) => (
        <div key={index}>
          <DesktopMenuItem {...module} />
        </div>
      ))}
      <li style={{ height: "40px" }} className={style.menu_parent}>
        <Button
          styleType="primary"
          buttonType="button"
          onClick={() => history.push(`/sell-vehicle/${vehicleTypes[0]}`)}
          extraProps={{
            style: {
              backgroundColor: "#dc0000",
              color: "#fff",
              padding: "0 15px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            },
          }}
        >
          <Plus width="15" height="15" color="#fff" />
          {locale("sell_vehicle")}
        </Button>
      </li>
    </>
  );
}

export default DesktopHeader;
